module.exports = "https://cdn2-fs.clearscore.com/flux/images/40fa5b43cae4751bb0590e5a3f562342.jpg";